import React from "react";
import { useParams } from "react-router-dom";

import { NoteItem } from "../../../../common/components/notes/hooks/state/NoteItem";
import { Notes } from "../../../../common/components/notes/Notes";
import { NoteSubjectType } from "../../../../common/types/NoteSubjectType";
import { SprintAccessRight } from "../../../../core/security/SprintAccessRight";

interface NotesSectionProps {
    subjectType: NoteSubjectType;
    isFormDisabled?: boolean;
    renderBadge?: (note: NoteItem) => JSX.Element;
}

export const NotesSection: React.FunctionComponent<NotesSectionProps> = ({
    subjectType,
    isFormDisabled,
    renderBadge
}: NotesSectionProps) => {
    const { assetId } = useParams<{ assetId: string }>();

    return (
        <Notes
            subjectType={subjectType}
            subjectId={assetId}
            sourceIds={[assetId]}
            isInlineCreateSupported={true}
            isDeleteSupported={true}
            style={{ height: 450 }}
            accessRights={[SprintAccessRight.AssetsReadWrite]}
            disabled={isFormDisabled}
            renderBadge={renderBadge}
        />
    );
};
